import { SvgIcon, SvgIconProps } from '@mui/material';

export const Logo = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM12 8l-1.49 2.75L9.5 13h5l-1.01-2.25L12 8z"
        />
    </SvgIcon>
); 